<template>
  <v-flex
    column
    role="region"
    aria-label="Notes content"
  >
    <v-parallax
      src="https://gm.goz.fun/wp-content/uploads/2023/03/notes-cover.png"
      height="350"
      role="img"
      aria-label="Notes section banner"
    />
    <v-card flat>
      <v-layout
        column
        pb-2
        role="region"
        aria-label="Notes layout"
      >
        <v-flex
          xs12
          sm12
          md12
          lg8
          justify-center
        >
          <search
            subject="notes"
            :limit="limit"
            @onChangedText="onSearchChange"
          />

          <posts
            :posts="posts"
            :title="$t('components.notes.title')"
            :is-loading="isLoading"
            role="region"
            aria-label="Notes posts section"
          />
        </v-flex>
      </v-layout>
    </v-card>
  </v-flex>
</template>


<script>
import { toPaginatedPosts, searchPost } from "@/utils/post.utils";

export default {
  name: "NotesLayout",
  components: {
    Posts: () => import("@/components/Views/Posts.vue"),
    Search: () => import("@/components/Views/Search.vue"),
  },
  data() {
    return {
        apiNotes: [],
        searchText: "",
        limit: 100,
        isLoading: true,
    }
  },
  computed: {
      posts() {
          return this.searchText
            ? toPaginatedPosts(searchPost(this.apiNotes, this.searchText), "")
            : toPaginatedPosts(this.apiNotes, this.$route.query.slug);
      }
  },
  watch: {
      posts() {
        this.isLoading = false;
      }
  },
  async mounted() {
    this.apiNotes = await this.$api.getNotes(this.limit);
  },
  methods: {
    async onSearchChange(searchText) {
        this.isLoading = true;
        this.searchText = searchText;
    }
  }
}
</script>
